<template>
  <a-layout class="auth">
    <a-layout-header>
      <Header :is-login="false" />
    </a-layout-header>
    <div class="content">
      <router-view />
    </div>
    <footer>
      <!-- Copyright © {{ new Date().getFullYear() }} Silkrode Technologies Co. Ltd
      All rights reserved -->
    </footer>
  </a-layout>
</template>

<script>
import Header from '@GC/Header.vue'

export default {
  name: 'Auth',
  components: {
    Header
  }
}
</script>
